var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Provider } from 'mobx-react';
import { ThemeProvider } from 'styled-components';
import FloorPlanEdit from './containers/FloorPlan/FloorPlanEdit';
import { floorPlannerAdminTheme } from './utils/themes';
import { FloorPlanStore } from './stores/floorplan';
import { LabelsStore } from './stores/labels';
import { SpacesStore } from './stores/spaces';
var FloorPlannerApp = /** @class */ (function (_super) {
    __extends(FloorPlannerApp, _super);
    function FloorPlannerApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.floorPlanStore = new FloorPlanStore();
        _this.labelsStore = new LabelsStore(_this.floorPlanStore);
        _this.spacesStore = new SpacesStore(_this.floorPlanStore);
        _this.stores = {
            floorPlanStore: _this.floorPlanStore,
            labelsStore: _this.labelsStore,
            spacesStore: _this.spacesStore,
        };
        return _this;
    }
    FloorPlannerApp.prototype.render = function () {
        return (React.createElement(Provider, __assign({}, this.stores),
            React.createElement(ThemeProvider, { theme: floorPlannerAdminTheme },
                React.createElement(FloorPlanEdit, { moveId: this.props.moveId, accessToken: this.props.accessToken }))));
    };
    return FloorPlannerApp;
}(React.Component));
export default FloorPlannerApp;
//# sourceMappingURL=FloorPlannerApp.js.map